module.exports = __webpack_public_path__ + "public/img/Sale08.c8534629.png";